import React from 'react';
import { SvgIcon } from '@mui/material';


const BlinkingWarningIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 116.99 116.99"  // Match the original viewBox of your SVG
      sx={{
        width: '6mm',
        height: '6mm',
        animation: 'blink 1s infinite', // CSS animation to make it blink
        '@keyframes blink': {
          '0%': { opacity: 1 },
          '50%': { opacity: 0 },
          '100%': { opacity: 1 },
        },
      }}
    >
      {/* Your custom SVG paths */}
      <rect fill="#FFD000" x="56.32" y="17.33" width="4.34" height="63.55"/>
      <path fill="#FFD000" d="M58.49,4.33C28.62,4.33,4.33,28.64,4.33,58.49s24.29,54.16,54.16,54.16,54.16-24.29,54.16-54.16S88.34,4.33,58.49,4.33ZM58.49,105.43c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5,6.5,2.92,6.5,6.5-2.92,6.5-6.5,6.5ZM64.99,85.21h-13V13h13v72.21ZM58.49,96.77c-1.2,0-2.17.98-2.17,2.16s.97,2.17,2.17,2.17,2.17-.97,2.17-2.17-.99-2.16-2.17-2.16Z"/>
      <path 
        fill="none"
        strokeWidth="0"
        d="M58.49,0C26.18,0,0,26.2,0,58.49s26.18,58.49,58.49,58.49,58.49-26.18,58.49-58.49S90.78,0,58.49,0ZM58.49,112.65c-29.87,0-54.16-24.29-54.16-54.16S28.62,4.33,58.49,4.33s54.16,24.31,54.16,54.16-24.31,54.16-54.16,54.16Z"/>
    </SvgIcon>
  );
};


export default BlinkingWarningIcon;